module.exports = __webpack_public_path__ + "static/img/projectI1.6ac051e.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/mImg/projectI1.png
// module id = qjF4
// module chunks = 0